import { rootReducer } from '..';
import { InitialState } from './reducer';

type RootState = ReturnType<typeof rootReducer>;

export const calendarDataSelector = (state: RootState): InitialState[] => state.psychologistCalender;
